import Helper from '../helpers/Helper';

export default class Album {
    constructor() {
        this.el = null;
    }
    init(el) {
        if (el === undefined || el === null) {
            return;
        }
        this.el = el;
        this.changePreviewImage();
    }
    changePreviewImage() {
        this.el.addEventListener('click', (e) => {
            if (e.target.closest('.album__thumbnail-image') !== null) {
                let el = e.target.closest('.album__thumbnail-image');

                if (!Helper.isInsideEditor()) {
                    this.previewImageStyle = '';

                    // toggle thumbnail active class
                    this.el.querySelectorAll('.album__thumbnail-image').forEach((el2) => {
                        el2.classList.remove('album__thumbnail-image--active');
                    });
                    el.classList.add('album__thumbnail-image--active');

                    if (
                        el.style.backgroundImage !== null &&
                        el.style.backgroundImage !== undefined &&
                        el.style.backgroundImage !== ''
                    ) {
                        this.previewImageStyle +=
                            'background-image:url( ' +
                            el.style.backgroundImage
                                .slice(4, -1)
                                .replace(/"/g, '')
                                .replace('w=180&', '') +
                            ');';
                    }

                    if (
                        el.style.backgroundSize !== null &&
                        el.style.backgroundSize !== undefined &&
                        el.style.backgroundSize !== ''
                    ) {
                        this.previewImageStyle +=
                            'background-size:' + el.style.backgroundSize + ';';
                    }

                    if (
                        el.style.backgroundPositionY !== null &&
                        el.style.backgroundPositionY !== undefined &&
                        el.style.backgroundPositionY !== ''
                    ) {
                        this.previewImageStyle +=
                            'background-position-y:' + el.style.backgroundPositionY + ';';
                    }

                    if (
                        el.style.backgroundPositionX !== null &&
                        el.style.backgroundPositionX !== undefined &&
                        el.style.backgroundPositionX !== ''
                    ) {
                        this.previewImageStyle +=
                            'background-position-x:' + el.style.backgroundPositionX + ';';
                    }

                    //replace preview image
                    this.el
                        .querySelector('.album__btn-lightgallery-preview')
                        .setAttribute(
                            'href',
                            el.getAttribute('data-thumbnail').replace('w=300&h=175&', '')
                        );
                    this.el
                        .querySelector('.image-container--preview')
                        .setAttribute('style', this.previewImageStyle);
                }

                //remove duplicated lightgallery link from DOM
                this.el
                    .querySelectorAll('.album__btn-lightgallery-thumbnail--desktop')
                    .forEach((el3, thumbnail__index) => {
                        if (
                            thumbnail__index ===
                            parseInt(
                                el.closest('.album__thumbnail-item').getAttribute('thumbnail-index')
                            )
                        ) {
                            el3.setAttribute('data-lightgallery-group', '');
                        } else {
                            el3.setAttribute(
                                'data-lightgallery-group',
                                el3.getAttribute('data-group')
                            );
                        }
                    });
            }
        });
    }
}
